export default __webpack_public_path__ + "static/media/saw-logo-inverse1.6f7f3860.svg";